export default __webpack_public_path__ + "images/code-breaker.png";